import images from "./images";
import { FaArchway, FaPaintRoller } from "react-icons/fa";

const About = {
  sub: "about us",
  heading: "Your Creative Design Partner",
  description: [
    "At Lumina Designs, we bring over 35 years of experience to the world of architecture and interior design, crafting exceptional spaces that inspire.",
  ],
  experience: {
    year: "35",
    text: "years of experience",
  },
  points: [
    {
      icon: <FaArchway />, // Archway icon
      title: "Architecture",
      content: "We specialize in architectural design that transforms spaces into functional and aesthetic marvels. Lorem ipsum dolor sit amet elit.",
    },
    {
      id: 2,
      icon: <FaPaintRoller />, // Paint Roller icon
      title: "Interior Design",
      content: "Our interior design expertise creates harmonious interiors that reflect your style and comfort. Lorem ipsum dolor sit amet elit.",
    },
  ],
  image: {
    src1: images.about1,
    src2: images.about2,
    alt1: "About-Image1",
    alt2: "About-Image2",
  },
  button: {
    text: "Contact Us",
    link: "Contact-us",
  },
};

export default About;